import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { UserState } from "./profile.state";

export const UserActions = createActionGroup({
  source: 'User Profile',
  events: {
    'User Login': props<UserState>(),
    'Update User': props<UserState>(),
    'User Logout': emptyProps()
  }
})